// Video Topic JavaScript
// Handles video loading, question navigation, and related topics

// Global variables
var player;
var currentVideoId = null;
var playerIframeId = null; // Track which iframe the player is bound to
var pendingPlayerInitToken = 0;
var pendingPlayerInitTimer = null;
var playersByIframeId = {};
var playerReadyByIframeId = {};
var pendingVideoByIframeId = {};
var currentActiveIframeId = null;

// Function to handle question button clicks - defined early so it can be used everywhere
function handleQuestionClick(btn) {
  const now = Date.now();
  // Try multiple ways to get the video ID
  const videoId = btn.dataset.videoId || btn.getAttribute('data-video-id');
  const startTime = btn.dataset.startTime || btn.getAttribute('data-start-time') || 0;
  const disclaimer = btn.dataset.disclaimer || btn.getAttribute('data-disclaimer') || '';  
  const questionText = (btn.textContent || '').replace(/\s+/g, ' ').trim();
  console.log('handleQuestionClick called:', { videoId, startTime, disclaimer, btn });
  
  if (!videoId) {
    console.error('No video ID found on question button:', btn);
    console.error('Button dataset:', btn.dataset);
    console.error('Button attributes:', Array.from(btn.attributes).map(a => `${a.name}="${a.value}"`));
    return;
  }
  
  // Remove active class from all buttons
  document.querySelectorAll(".question-btn").forEach(b => {
    b.classList.remove("active");
  });
  
  // Add active class to clicked button
  btn.classList.add("active");

  // GA4/GTM question click event
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'question_click',
    question: questionText,
    page_url: window.location.href
  });
  
  // Force reflow to ensure CSS updates
  btn.offsetHeight;
  
  // Find which topic block contains this button
  const buttonTopicBlock = btn.closest('.expert-topic-block');
  if (!buttonTopicBlock) {
    console.error('Question button is not inside an expert-topic-block');
    return;
  }
  
  // Hide hovering video when question is clicked
  const hoveringWrappers = buttonTopicBlock.querySelectorAll('.hovering-video-wrapper');
  hoveringWrappers.forEach(wrapper => {
    wrapper.classList.add('hidden');
    const video = wrapper.querySelector('video');
    if (video) {
      video.pause();
    }
  });
  
  const isMobile = window.innerWidth <= 1024;
  let mainVideo = null;
  let iframeId = null;
  const topicSystemId = buttonTopicBlock.getAttribute('data-system-id') || 'topic';
  
  // Find video wrapper within the button's topic block
  let videoWrapper = null;
  if (isMobile) {
    const mobileView = buttonTopicBlock.querySelector('.video-left.mobile-view');
    if (mobileView) {
      videoWrapper = mobileView.querySelector('.mobileVideoWrapper');
      iframeId = `mobileMainVideo-${topicSystemId}`;
    }
  } else {
    const desktopView = buttonTopicBlock.querySelector('.video-left.desktop-view');
    if (desktopView) {
      videoWrapper = desktopView.querySelector('.videoWrapper');
      iframeId = `mainVideo-${topicSystemId}`;
    }
  }
  
  if (!videoWrapper) {
    console.error('Video wrapper not found in topic block');
    console.error('Button topic block:', buttonTopicBlock);
    console.error('Is mobile:', isMobile);
    return;
  }
  
  // Show the video wrapper (remove hidden class)
  videoWrapper.classList.remove('hidden');
  
  // Remove paused class
  videoWrapper.classList.remove('paused');
  
  // Get or create iframe
  mainVideo = videoWrapper.querySelector('iframe, .youtube-video-iframe');
  if (!mainVideo) {
    // Create a player container once; YouTube API will create the iframe
    mainVideo = document.createElement('div');
    mainVideo.id = iframeId;
    mainVideo.className = 'youtube-video-iframe';
    
    const overlayBlocker = videoWrapper.querySelector('.overlayBlocker');
    if (overlayBlocker) {
      videoWrapper.insertBefore(mainVideo, overlayBlocker);
    } else {
      videoWrapper.appendChild(mainVideo);
    }
  }
  
  console.log('Found mainVideo iframe:', mainVideo.id || 'no-id', mainVideo.src);
  
  currentActiveIframeId = mainVideo.id;

  // Track latest request per iframe to avoid rapid click collisions
  pendingVideoByIframeId[mainVideo.id] = {
    videoId: videoId,
    startTime: parseInt(startTime) || 0
  };
  
  // Initialize player once per iframe and reuse it
  if (window.YT && window.YT.Player && mainVideo.id) {
    if (!playersByIframeId[mainVideo.id]) {
      playersByIframeId[mainVideo.id] = new YT.Player(mainVideo.id, {
        playerVars: {
          rel: 0,
          modestbranding: 1,
          playsinline: 1,
          controls: 1,
          fs: 0,
          iv_load_policy: 3,
          disablekb: 1,
          origin: window.location.origin
        },
        events: {
          'onStateChange': onPlayerStateChange,
          'onReady': function() {
            playerReadyByIframeId[mainVideo.id] = true;
            const pending = pendingVideoByIframeId[mainVideo.id];
            if (pending) {
              playersByIframeId[mainVideo.id].loadVideoById({
                videoId: pending.videoId,
                startSeconds: pending.startTime || 0
              });
              currentVideoId = pending.videoId;
            }
          }
        }
      });
    } else if (playerReadyByIframeId[mainVideo.id]) {
      const pending = pendingVideoByIframeId[mainVideo.id];
      if (pending) {
        playersByIframeId[mainVideo.id].loadVideoById({
          videoId: pending.videoId,
          startSeconds: pending.startTime || 0
        });
        currentVideoId = pending.videoId;
      }
    }
  }
  
  // Update the disclaimer - separate for desktop and mobile
  const desktopDisclaimers = buttonTopicBlock.querySelectorAll('.video-disclaimer.desktop-view');
  const mobileDisclaimers = buttonTopicBlock.querySelectorAll('.video-disclaimer.mobile-view');
  
  if (isMobile) {
    // Update mobile disclaimer only
    if (mobileDisclaimers.length > 0) {
      if (disclaimer && disclaimer.trim() !== '') {
        mobileDisclaimers.forEach(el => {
          el.innerHTML = disclaimer;
          el.style.display = 'block';
        });
      } else {
        mobileDisclaimers.forEach(el => {
          el.style.display = 'none';
        });
      }
    }
    // Hide desktop disclaimer on mobile
    desktopDisclaimers.forEach(el => {
      el.style.display = 'none';
    });
  } else {
    // Update desktop disclaimer only
    if (desktopDisclaimers.length > 0) {
    if (disclaimer && disclaimer.trim() !== '') {
        desktopDisclaimers.forEach(el => {
        el.innerHTML = disclaimer;
        el.style.display = 'block';
      });
    } else {
        desktopDisclaimers.forEach(el => {
        el.style.display = 'none';
      });
    }
    }
    // Hide mobile disclaimer on desktop
    mobileDisclaimers.forEach(el => {
      el.style.display = 'none';
    });
  }
  
  // Hide overlays after video loads
  setTimeout(hideOverlays, 1000);
}

// Related topics now use simple navigation - no complex JavaScript needed
// Links navigate to /pages/ask-the-expert?topic={numeric_id} which reloads the page

// Load YouTube IFrame API
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

function shareVideo() {
  const shareUrl = window.location.href;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'experts_share',
    page_url: shareUrl
  });
  // Always copy link to clipboard
  navigator.clipboard.writeText(shareUrl).then(() => {
    showVideoLinkCopiedToast();
  }).catch(err => {
    console.error('Failed to copy link:', err);
    // Fallback: try using execCommand for older browsers
    const textArea = document.createElement('textarea');
    textArea.value = shareUrl;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      showVideoLinkCopiedToast();
    } catch (e) {
      console.error('Failed to copy link:', e);
    }
    document.body.removeChild(textArea);
  });
}

function showVideoLinkCopiedToast() {
  const toastContainer = document.getElementById('video-link-copied-toast');
  const toast = toastContainer?.querySelector('.video-success-toast');
  
  if (!toastContainer || !toast) return;
  
  // Remove hide class and add show class
  toast.classList.remove('hide');
  toastContainer.classList.add('show');
  
  // Auto-hide after 3 seconds
  const autoHideTimer = setTimeout(() => {
    hideVideoLinkCopiedToast();
  }, 3000);
  
  // Store timer so we can clear it if user closes manually
  toastContainer._autoHideTimer = autoHideTimer;
}

function hideVideoLinkCopiedToast() {
  const toastContainer = document.getElementById('video-link-copied-toast');
  const toast = toastContainer?.querySelector('.video-success-toast');
  
  if (!toastContainer || !toast) return;
  
  // Clear auto-hide timer if it exists
  if (toastContainer._autoHideTimer) {
    clearTimeout(toastContainer._autoHideTimer);
    toastContainer._autoHideTimer = null;
  }
  
  // Add hide class for animation
  toast.classList.add('hide');
  
  // Remove show class after animation
  setTimeout(() => {
    toastContainer.classList.remove('show');
    toast.classList.remove('hide');
  }, 300);
}

function onYouTubeIframeAPIReady() {
  // YouTube API is ready - player will be initialized when user clicks a question
  // Don't auto-create player on page load since we show hovering video first
  console.log('YouTube IFrame API ready');
}

function onPlayerReady(event) {
  // Hide overlays when player is ready
  hideOverlays();
}

function onPlayerStateChange(event) {
  // Find video wrapper based on active iframe
  const activeIframe = currentActiveIframeId
    ? document.getElementById(currentActiveIframeId)
    : null;
  const videoWrapper = activeIframe
    ? activeIframe.closest('.mobileVideoWrapper, .videoWrapper')
    : null;
  
  // Only block interactions when the video ends (avoid blocking on pause)
  if (event.data == YT.PlayerState.ENDED) {
    if (videoWrapper) {
      videoWrapper.classList.add('paused');
    }
    hideOverlays();
    showHoveringVideoOnEnd();
    return;
  }

  // Allow normal controls on pause/cued
  if (videoWrapper) {
    videoWrapper.classList.remove('paused');
  }

  if (event.data == YT.PlayerState.PAUSED || event.data == YT.PlayerState.CUED) {
    hideOverlays();
  }
}

// Function to show hovering video when YouTube video ends
function showHoveringVideoOnEnd() {
  const selectedTopicBlock = document.querySelector('.expert-topic-block.is-selected') || 
                              document.querySelector('.expert-topic-block:not([style*="display: none"])');
  
  if (!selectedTopicBlock) return;
  
  const hoveringWrappers = selectedTopicBlock.querySelectorAll('.hovering-video-wrapper');
  const youtubeWrappers = selectedTopicBlock.querySelectorAll('.videoWrapper, .mobileVideoWrapper');
  const disclaimers = selectedTopicBlock.querySelectorAll('.video-disclaimer');
  const questionBtns = selectedTopicBlock.querySelectorAll('.question-btn');
  
  // Only proceed if there are hovering videos to show
  if (hoveringWrappers.length === 0) return;
  
  // Show hovering video wrappers
  hoveringWrappers.forEach(wrapper => {
    wrapper.classList.remove('hidden');
    const video = wrapper.querySelector('video');
    if (video) {
      video.play().catch(e => console.log('Hovering video play failed:', e));
    }
  });
  
  // Hide YouTube wrappers
  youtubeWrappers.forEach(wrapper => {
    wrapper.classList.add('hidden');
    // Stop video without destroying the player/iframe
    try {
      if (currentActiveIframeId && playersByIframeId[currentActiveIframeId]) {
        playersByIframeId[currentActiveIframeId].stopVideo();
      }
    } catch (e) {
      // ignore
    }
  });
  
  // Hide all disclaimers (both desktop and mobile)
  disclaimers.forEach(d => d.style.display = 'none');

  // Remove active class from all question buttons
  questionBtns.forEach(btn => btn.classList.remove('active'));

  
  // Reset player reference
  player = null;
  playerIframeId = null;
}

function hideOverlays() {
  // Ensure overlay blocker is visible when paused
  const activeIframe = currentActiveIframeId
    ? document.getElementById(currentActiveIframeId)
    : null;
  const videoWrapper = activeIframe
    ? activeIframe.closest('.mobileVideoWrapper, .videoWrapper')
    : null;
    
  if (videoWrapper && currentActiveIframeId && playersByIframeId[currentActiveIframeId]) {
    try {
      const playerState = playersByIframeId[currentActiveIframeId].getPlayerState();
      if (playerState == YT.PlayerState.ENDED) {
        videoWrapper.classList.add('paused');
      } else {
        videoWrapper.classList.remove('paused');
      }
    } catch (e) {
      // Player might not be ready yet
    }
  }
  
  // Try to hide YouTube title overlay and copy link using postMessage
  const mainVideo = currentActiveIframeId
    ? document.getElementById(currentActiveIframeId)
    : document.getElementById('mainVideo');
  if (mainVideo && mainVideo.contentWindow) {
    try {
      // Hide title overlay
      mainVideo.contentWindow.postMessage('{"event":"command","func":"hideOverlays","args":""}', '*');
      // Try to hide specific YouTube UI elements
      mainVideo.contentWindow.postMessage('{"event":"command","func":"setOption","args":["showinfo",0]}', '*');
    } catch (e) {
      // postMessage might fail due to cross-origin restrictions
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  // No need to stop iframes - they're created dynamically now
  // All topic blocks start with display: none and no iframes exist yet
  // Hovering video plays on initial load, no YouTube player until user clicks a question

  // Attach event listeners to all question buttons
  document.querySelectorAll(".question-btn").forEach(btn => {
    btn.addEventListener("click", function() {
      handleQuestionClick(this);
    });
  });
  
  // Attach close button listener for toast
  const toastCloseBtn = document.getElementById('video-toast-close-btn');
  if (toastCloseBtn) {
    toastCloseBtn.addEventListener('click', hideVideoLinkCopiedToast);
  }
  
  // Related topic cards now use simple href navigation - no JavaScript needed
  // They navigate to /pages/ask-the-expert?topic={numeric_id} which reloads the page
  
  // Periodically check and hide overlays (as a fallback)
  setInterval(() => {
    if (player) {
      try {
        const playerState = player.getPlayerState();
        const isMobile = window.innerWidth <= 1024;
        const videoWrapper = isMobile 
          ? document.querySelector('.mobileVideoWrapper')
          : document.querySelector('.videoWrapper');
        if (playerState == YT.PlayerState.PAUSED || playerState == YT.PlayerState.ENDED) {
          if (videoWrapper) {
            videoWrapper.classList.add('paused');
          }
        } else {
          if (videoWrapper) {
            videoWrapper.classList.remove('paused');
          }
        }
      } catch (e) {
        // Player might not be ready
      }
    }
  }, 500);
});